import { TableSchema } from '../metadata-schema';

export const dim_mw_medewerker: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_mw_medewerker",
	"description": "Definitie voor dimension tabel dim_mw_medewerker uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"mw_abb_geslacht": {
			"type": "string",
			"label": "Geslacht",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_abb_medewerker": {
			"type": "string",
			"label": "Docent (afkorting)",
			"category": "Vak",
			"example": "JNS, VDK",
			"description": "De afkorting van de docent. Veel scholen geven docenten een twee- of drieletterige afkorting om weer te geven in bijvoorbeeld roosters.",
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_co_externid": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_d_indienst": {
			"type": "string",
			"format": "date",
			"label": "Datum in dienst",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"mw_fun_d_uitdienst": {
			"type": "string",
			"format": "date",
			"label": "Datum uit dienst",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"mw_fun_is_docent": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"mw_fun_is_mentor": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"mw_fun_nr_dienstjaren": {
			"type": "integer",
			"label": "Dienstjaren",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"mw_fun_volledige_naam": {
			"type": "string",
			"label": "Volledige naam",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_id_medewerker": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_ids_vestiging": {
			"type": "array",
			"items": {
				"type": "string"
			},
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"mw_is_ondersteunend": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Ondersteunend",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"mw_is_onderwijzend": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Onderwijzend",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"mw_nm_achternaam": {
			"type": "string",
			"label": "Achternaam",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_nm_emailadres": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_nm_functie": {
			"type": "string",
			"label": "Functie",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"mw_nm_medewerker": {
			"type": "string",
			"label": "Docent",
			"category": "Vak",
			"description": "De achternaam, voornaam/-letters, eventueel voorvoegsel en afkorting van de docent.",
			"example": "Jansen, L. (JNS); Dijk, Evert van (VDK)",
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_nm_roepnaam": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_nm_voorvoegsel": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_nr_medewerker": {
			"type": "integer",
			"label": "Nummer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_pic_pasfoto": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"bestuur": true
			}
		},
		"mw_pk_key": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			},
			"blocklist": {
				"bestuur": true
			}
		}
	}
};
